<template>
  <div class="loading">
    <div v-for="index in 12" :key="index" />
  </div>
</template>
